import script from "./AdminAdsTxtManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAdsTxtManager.vue?vue&type=script&setup=true&lang=js"

import "./AdminAdsTxtManager.vue?vue&type=style&index=0&id=7c6bb390&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c6bb390"]])

export default __exports__